import { useState } from "react"

export const usePaginationState = (
  initialPageIndex = 0,
  initialPageSize = 10,
) => {
  const [pagination, onPaginationChange] = useState({
    pageIndex: initialPageIndex,
    pageSize: initialPageSize,
  })

  return { pagination, onPaginationChange }
}
